import React from "react";
import { Badge } from "../ui/badge";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { formatDate } from "./constants";

const statusColors = { pending: "bg-slate-100 text-slate-600", in_progress: "bg-blue-100 text-blue-700", delivered: "bg-emerald-100 text-emerald-700", overdue: "bg-red-100 text-red-700", accepted: "bg-emerald-100 text-emerald-700", rejected: "bg-red-100 text-red-700" };

export function DeliverablesTab({ deliverables, expanded, onUpdateStatus }) {
  if (deliverables.length === 0) {
    return <p className="text-xs text-slate-400 text-center py-6">No deliverables defined. Add deliverables during contract drafting in the wizard.</p>;
  }

  return (
    <div className="space-y-3">
      <div className="flex justify-between items-center">
        <p className="text-sm text-slate-500">{deliverables.length} deliverable(s)</p>
        <div className="flex gap-2 text-[10px] text-slate-400">
          <span>{deliverables.filter(d => d.tracking_status === "delivered").length} delivered</span>
          <span>{deliverables.filter(d => d.tracking_status === "overdue" || (!d.tracking_status && d.delivery_date && new Date(d.delivery_date) < new Date())).length} overdue</span>
        </div>
      </div>
      <div className={`space-y-2 overflow-y-auto ${expanded ? "max-h-[calc(100vh-350px)]" : "max-h-[400px]"}`}>
        {deliverables.map((del, idx) => {
          const isOverdue = !del.tracking_status && del.delivery_date && new Date(del.delivery_date) < new Date();
          const status = del.tracking_status || (isOverdue ? "overdue" : "pending");
          return (
            <div key={`del-${idx}`} className={`p-3 border rounded-sm ${isOverdue ? "border-red-200 bg-red-50/20" : ""}`}>
              <div className="flex items-center justify-between gap-2">
                <div className="flex-1 min-w-0">
                  <p className="text-sm font-medium">{del.description}</p>
                  <div className="flex items-center gap-3 mt-1 text-[10px] text-slate-400">
                    {del.delivery_date && <span>Due: {formatDate(del.delivery_date)}</span>}
                    {del.recurrence && del.recurrence !== "once" && <Badge variant="outline" className="text-[9px]">{del.recurrence}</Badge>}
                    {del.occurrence && <span>#{del.occurrence} of {del.total_occurrences}</span>}
                  </div>
                </div>
                <Select value={status} onValueChange={(v) => onUpdateStatus(idx, v)}>
                  <SelectTrigger className={`rounded-sm h-7 w-28 text-[10px] ${statusColors[status] || ""}`} data-testid={`del-status-${idx}`}>
                    <SelectValue />
                  </SelectTrigger>
                  <SelectContent>
                    <SelectItem value="pending">Pending</SelectItem>
                    <SelectItem value="in_progress">In Progress</SelectItem>
                    <SelectItem value="delivered">Delivered</SelectItem>
                    <SelectItem value="accepted">Accepted</SelectItem>
                    <SelectItem value="rejected">Rejected</SelectItem>
                    <SelectItem value="overdue">Overdue</SelectItem>
                  </SelectContent>
                </Select>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
}
